// Standard UTM Params
export const UTM_MEDIUM = 'utm_medium';
export const UTM_SOURCE = 'utm_source';
export const UTM_CAMPAIGN = 'utm_campaign';
export const UTM_CONTENT = 'utm_content';
export const UTM_TERM = 'utm_term';
export const UTM_ADGID = 'utm_adgid';
export const UTM_NTWK = 'utm_ntwk';
export const UTM_SUBSITE = 'utm_subsite';
export const UTM_CTA = 'utm_cta';
export const UTM_EXTERNALID = 'utm_externalid';
export const UTM_GEO = 'utm_geo';
export const UTM_CAT = 'utm_cat';
